import { border, color, font, spacing } from './constants';

import { darken, lighten } from 'polished';
import { css } from 'styled-components';

const heights = { small: '2rem', default: '2.5rem', large: '3rem' };

const buttonStyles = css`
  appearance: none;
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  height: ${heights.default};
  line-height: calc(${heights.default} - ${border.borderWidthRegular} * 2);
  max-width: 100%;
  padding: 0 ${spacing.spacingM};
  -webkit-font-smoothing: antialiased;
  -webkit-touch-callout: none;
  text-rendering: optimizeLegibility;
  cursor: pointer;
  user-select: none;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  text-transform: none;
  outline: 0;
  color: ${props => (props.theme.button && props.theme.button.color) || '#fff'};
  background-color: ${props =>
    (props.theme.button && props.theme.button.topBackgroundColor) || '#676f7e'};
  margin: 0;
  margin-right: 1rem;

  &:last-child {
    margin-right: 0;
    ${props => props.theme.currentTheme === 'EVOLUTION' && `
      margin-bottom: 10px;
    `}
  }

  border: ${border.borderWidthRegular} solid transparent;
  border-radius: ${props => (props.theme.button && props.theme.button.borderRadius) || 0};
  background: ${props =>
    (props.theme.button && props.theme.button.backgroundColor) || color.primaryButton};
  ${props => props.theme.currentTheme === 'EVOLUTION' && `
    background-color: ${props.theme?.primaryColor};
  `}

  font-size: ${font.fontSizeRegular};

  will-change: border-color, background;
  transition: border-color linear 50ms,
              background linear 50ms;

  ${props =>
    !props.disabled &&
    `
    &:hover,
    &:focus {
      color: ${(props.theme.button && props.theme.button.color) || '#fff'};
      background-color: ${lighten(
        0.05,
        (props.theme.button && props.theme.button.backgroundColor) || color.primaryButton
      )};
       ${props.theme.currentTheme === 'EVOLUTION' && `
        background-color: ${lighten(0.05, props.theme?.primaryColor)};
      `}
    }
    &:active {
      background-color: ${darken(
        0.1,
        (props.theme.button && props.theme.button.backgroundColor) || color.primaryButton
      )}
      ${props.theme.currentTheme === 'EVOLUTION' && `
        background-color: ${darken(0.1, props.theme?.primaryColor)};
      `}
    }
  `}

  & > svg {
    vertical-align: middle;
  }

  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  ${props =>
    props.small &&
    `
    height: 2rem;
    padding: 0 0.5rem;
    line-height: calc(2rem - ${border.borderWidthRegular} * 2);
  `}

  ${props =>
    props.large &&
    `
    font-size: ${font.fontSizeM};
    height: 3rem;
    line-height: calc(3rem - ${border.borderWidthRegular} * 2);
  `}

  ${props =>
    !props.disabled &&
    props.neutral &&
    `
    color: #676f7e;
    background-color: #eff2f5;

    &:hover,
    &:focus {
      color: ${lighten(0.1, '#676f7e')};
      background-color: ${lighten(0.1, '#eff2f5')};
    }
    &:active {
      background-color: ${darken(0.1, '#eff2f5')}
    }
  `}

  ${props =>
    props.flat &&
    `
    background: none;
    color: ${(props.theme.button && props.theme.button.topBackgroundColor) || '#676f7e'};

    &:not(:disabled):hover,
    &:not(:disabled):focus {
      background: none;
      color: ${(props.theme.button && props.theme.button.topBackgroundColor) || '#676f7e'};
    }
  `}
  ${props =>
    props.disabled &&
    `
      background-color: ${props.theme.currentTheme === 'EVOLUTION' ? props.theme?.secondaryColor : '#b3b3b3'};
      color: ${props.theme.currentTheme === 'EVOLUTION' ? props.theme?.disableTextColor : 'graytext'};
      cursor: not-allowed;
    `}

  ${props => props.theme.currentTheme === 'EVOLUTION' && `
    padding: 12px 16px;
    border-radius: ${props.theme?.inputBorderRadius || '12px'};
    margin: 0;
    height: ${props.theme?.buttonHeight || '40px'};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px;
    @media (max-width: 390px) {
      width: 100%
    }
  `}
`;

export default buttonStyles;
